import { event } from "vue-gtag";
import { reportError } from "./ErrorHandling";

function calculateOrderItemsPrice(orderItems) {
    return orderItems.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
    );
}

export function reportViewCart(orderItems) {
    try {
        event("view_cart", {
            items: [],
            currency: "EUR",
            value: calculateOrderItemsPrice(orderItems),
        });
    } catch (error) {
        reportError(error);
    }
}

/**
 * @param {{
 *  id: string;
 *  name: string;
 *  price: number;
 * }[]} items
 */
export function reportViewItem(items) {
    try {
        event("view_item", {
            items: items.map((item) => ({
                item_id: item.id,
                item_name: item.name,
                price: item.price,
            })),
            currency: "EUR",
            value: items.reduce((acc, item) => acc + item.price, 0),
        });
    } catch (error) {
        reportError(error);
    }
}

export function reportAddToCart(orderItems) {
    try {
        const price = calculateOrderItemsPrice(orderItems);

        event("add_to_cart", {
            items: [
                {
                    item_name: "placeholder until we have products here",
                    price: price,
                    quantity: 1,
                },
            ], // TODO - add items
            currency: "EUR",
            value: price,
        });
    } catch (error) {
        reportError(error);
    }
}

export function reportRemoveFromCart(orderItems) {
    try {
        const price = calculateOrderItemsPrice(orderItems);

        event("remove_from_cart", {
            items: [
                {
                    item_name: "placeholder until we have products here",
                    price: price,
                    quantity: 1,
                },
            ], // TODO - add items
            currency: "EUR",
            value: price,
        });
    } catch (error) {
        reportError(error);
    }
}

export function reportAddShippingInfo(orderItems) {
    try {
        const price = calculateOrderItemsPrice(orderItems);

        event("add_shipping_info", {
            items: [
                {
                    item_name: "placeholder until we have products here",
                    price: price,
                    quantity: 1,
                },
            ], // TODO - add items
            currency: "EUR",
            value: price,
        });
    } catch (error) {
        reportError(error);
    }
}

export function reportAddPaymentInfo(orderItems) {
    try {
        const price = calculateOrderItemsPrice(orderItems);

        event("add_payment_info", {
            items: [
                {
                    item_name: "placeholder until we have products here",
                    price: price,
                    quantity: 1,
                },
            ], // TODO - add items
            currency: "EUR",
            value: price,
        });
    } catch (error) {
        reportError(error);
    }
}

export function reportBeginCheckout(orderItems) {
    try {
        const price = calculateOrderItemsPrice(orderItems);

        event("begin_checkout", {
            items: [
                {
                    item_name: "placeholder until we have products here",
                    price: price,
                    quantity: 1,
                },
            ], // TODO - add items
            currency: "EUR",
            value: price,
        });
    } catch (error) {
        reportError(error);
    }
}

export function reportPurchase(order) {
    try {
        const price = order.total_price - order.price_delivery - order.vat;

        event("purchase", {
            currency: "EUR",
            value: price,
            transaction_id: order.id,
            coupon: order.discount_code,
            shipping: order.price_delivery,
            tax: order.vat,
            items: [
                {
                    item_name: "placeholder until we have products here",
                    price: price,
                    quantity: 1,
                },
            ], // TODO - add items
        });
    } catch (error) {
        reportError(error);
    }
}

export function reportConnectAppDemo() {
    try {
        event("connect_app_demo");
    } catch (error) {
        reportError(error);
    }
}
